import { createApp, Directive } from 'vue'
import App from './App.vue'
// import './pwa/registerServiceWorker'
import router from './router'
import { store, useStore } from './store'

import ElementPlus from 'element-plus'
import * as Icons from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'

import locale from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import { loadAllPlugins } from './plugins'
import 'normalize.css'
import * as directives from '@/directives'
import '@/permission'
import i18n from '@/locales/index'
import VueGridLayout from 'vue-grid-layout'
import print from 'vue3-print-nb'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import currency from 'currency.js'
import number from 'number-precision'
import { BASE_URL } from '@/utils/httpClient'
import { installPressFeedback } from '@/utils/motion'
import TableSplitter from '@/components/common/TableSplitter.vue'

// 防抖处理 Element Plus / vxe-table 引起的 ResizeObserver 循环通知
const debounce = (fn: (...args: any[]) => void, delay: number) => {
  let timer: any = null
  return function (this: any, ...args: any[]) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const _ResizeObserver = window.ResizeObserver
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback: any) {
      super(debounce(callback, 20))
    }
  }
}

installPressFeedback()

const app = createApp(App)
app.use(i18n)
app.use(ElementPlus as any, {
  locale, // 语言设置
  size: useStore().state.app.size || 'default' // 尺寸设置
})
app.use(print)

// app.config.globalProperties.$ELEMENT = {
//   size: 'dafault'
// }
// 加载所有插件
loadAllPlugins(app)

Object.keys(Icons).forEach(key => {
  app.component(key, Icons[key as keyof typeof Icons])
})
app.component('TableSplitter', TableSplitter)
app.config.globalProperties.$currency = currency
app.config.globalProperties.$number = number

// app.config.globalProperties.$api = isPro ? networkConfig.host : '/apis/'
app.provide('$api', BASE_URL)
// 自定义指令
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string ]: Directive })[key])
})

app.use(store).use(router).use(VueGridLayout).use(VXETable).mount('#app')
